"use client";
import { createContext, useContext, useState } from "react";

type NavigationGuardContextType = {
  isBlocking: boolean;                     
  setIsBlocking: (value: boolean) => void; 
};

const NavigationGuardContext = createContext<NavigationGuardContextType>({
  isBlocking: false,
  setIsBlocking: () => {},
});

export const NavigationGuardProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isBlocking, setIsBlocking] = useState(false);

  return (
    <NavigationGuardContext.Provider value={{ isBlocking, setIsBlocking }}>
      {children}
    </NavigationGuardContext.Provider>
  );
};

export const useNavigationGuard = () => useContext(NavigationGuardContext);
